"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./styles.scss");
const DropdownOptions = (0, react_1.forwardRef)(function DropdownOptions({ htmlId, filteredOptions, activeIndex, selectedServices, onOptionClick, onOptionMouseDown, value }, ref) {
    let index = 0;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: filteredOptions.map((category) => {
            var _a;
            return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("strong", Object.assign({ className: "category" }, { children: category.name })), (_a = category.services) === null || _a === void 0 ? void 0 : _a.map((option) => {
                        const i = index++;
                        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, clsx_1.default)({
                                "option-current": activeIndex === i,
                                "option-selected": selectedServices.indexOf(option) > -1,
                                "multiselect-option": true
                            }), id: `${htmlId}-${i}`, "aria-selected": selectedServices.indexOf(option) > -1 ? "true" : false, ref: (el) => {
                                if (activeIndex === i) {
                                    ;
                                    ref.current = el;
                                }
                            }, role: "option", onClick: () => {
                                onOptionClick(i);
                            }, onMouseDown: () => {
                                onOptionMouseDown(i);
                            } }, { children: (() => {
                                var _a, _b, _c;
                                const matches = (value !== null && value !== void 0 ? value : "")
                                    .toLowerCase()
                                    .trim()
                                    .split(" ")
                                    .map((v) => {
                                    var _a;
                                    return ({
                                        value: v,
                                        position: ((_a = option.name) !== null && _a !== void 0 ? _a : "")
                                            .toLowerCase()
                                            .indexOf(v)
                                    });
                                })
                                    .sort((a, b) => a.position = b.position === 0
                                    ? b.value.length - a.value.length
                                    : a.position - b.position), displayJSX = [];
                                let offset = 0;
                                for (const { position, value } of matches) {
                                    if (position < offset) {
                                        continue;
                                    }
                                    displayJSX.push((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: ((_a = option.name) !== null && _a !== void 0 ? _a : "").substr(offset, position - offset) }, displayJSX.length));
                                    displayJSX.push((0, jsx_runtime_1.jsx)("strong", { children: ((_b = option.name) !== null && _b !== void 0 ? _b : "").substr(position, value.length) }, displayJSX.length));
                                    offset = position + value.length;
                                }
                                displayJSX.push((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: ((_c = option.name) !== null && _c !== void 0 ? _c : "").substr(offset) }, displayJSX.length));
                                return displayJSX;
                            })() }), option.id));
                    })] }, category.id));
        }) }));
});
exports.default = DropdownOptions;
